import React, { useState } from "react";

interface HamburgerProps {
  isOpen: boolean
  toggleState: () => void
}

const Hamburger: React.FC<HamburgerProps> = ( {toggleState, isOpen} ) => {
  return (
    <button onClick={toggleState} className="md:hidden top-[21px] right-5 h-12 w-12 flex flex-col items-end justify-center gap-[6px]">
      <div className={`w-9 h-0.5 bg-cents-black rounded-sm transition-all duration-500 ${isOpen ? 'rotate-45 translate-y-2' : ''}`}></div>
      <div className={`w-6 h-0.5 bg-cents-black rounded-sm transition-all duration-500 ${isOpen ? 'opacity-0' : 'opacity-100'}`}></div>
      <div className={`w-3 h-0.5 bg-cents-black rounded-sm transition-all duration-500 ${isOpen ? '-rotate-45 -translate-y-2 w-9' : ''}`}></div>
    </button>
  )
}

export default Hamburger;

